import { InformationCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import type {
  WizParsedData,
  WizRenderContext,
} from '@/sections/poe/processors/wiz/types';

export function renderFindingSummary(
  parsed: WizParsedData,
  ctx: WizRenderContext
): void {
  const { vulnerabilityDescription, resourceData, wizId } = parsed;
  const { sections, tempTabs, mainTabKeys } = ctx;

  if (
    (vulnerabilityDescription || resourceData) &&
    mainTabKeys.includes('DETECTION')
  ) {
    sections['wiz_finding'] = (
      <div className="space-y-4">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="rounded-lg p-4">
            <h4 className="text-chariot-text-primary mb-2 font-semibold">
              Finding Summary
            </h4>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-chariot-text-secondary">Source:</span>
                <span className="text-chariot-accent font-medium">Wiz.io</span>
              </div>
              {wizId && (
                <div className="flex justify-between">
                  <span className="text-chariot-text-secondary">
                    Finding ID:
                  </span>
                  <code className="bg-chariot-background-secondary rounded px-2 py-1 text-xs">
                    {wizId}
                  </code>
                </div>
              )}
              <div className="flex justify-between">
                <span className="text-chariot-text-secondary">
                  Evidence Type:
                </span>
                <span className="font-medium">Vulnerability Assessment</span>
              </div>
            </div>
          </div>

          {resourceData && (
            <div className="rounded-lg p-4">
              <h4 className="text-chariot-text-primary mb-2 font-semibold">
                Asset Information
              </h4>
              <div className="space-y-2 text-sm">
                {resourceData?.subscription && (
                  <div>
                    <span className="text-chariot-text-secondary block">
                      Resource Type:
                    </span>
                    <span className="font-medium">Cloud Subscription</span>
                  </div>
                )}
                <div>
                  <span className="text-chariot-text-secondary block">
                    Platform:
                  </span>
                  <span className="font-medium">
                    {resourceData?.subscription?.includes('AWS')
                      ? 'Amazon Web Services'
                      : resourceData?.subscription?.includes('Azure')
                        ? 'Microsoft Azure'
                        : resourceData?.subscription?.includes('GCP')
                          ? 'Google Cloud Platform'
                          : 'Cloud Platform'}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>

        {vulnerabilityDescription && (
          <div className="border-error-light bg-error-selected rounded-lg border">
            <div className="border-error-light bg-error-light border-b px-4 py-2">
              <h5 className="text-error flex items-center font-semibold">
                <InformationCircleIcon className="mr-2 size-4" />
                Security Impact
              </h5>
            </div>
            <div className="p-4">
              <p className="text-error text-sm leading-relaxed">
                {vulnerabilityDescription.length > 200
                  ? `${vulnerabilityDescription.substring(0, 200)}...`
                  : vulnerabilityDescription}
              </p>
              {vulnerabilityDescription.length > 200 && (
                <span className="text-chariot-accent mt-2 text-xs">
                  View full description in Detection tab →
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    );
    tempTabs['DETECTION'].push({
      label: 'Wiz Finding',
      value: 'wiz_finding',
    });
  }
}
